
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { CategoryForm } from "./CategoryForm";
import { EpisodeCategory } from "../episodes/types";

interface CategoryEditDialogProps {
  category: EpisodeCategory | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSave: (category: any) => void;
}

export const CategoryEditDialog = ({ 
  category, 
  open, 
  onOpenChange, 
  onSave 
}: CategoryEditDialogProps) => {
  const handleSave = (categoryData: any) => {
    onSave(categoryData);
    onOpenChange(false);
  };

  const handleCancel = () => {
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>
            {category ? "Edit Episode Category" : "Create New Episode Category"}
          </DialogTitle>
        </DialogHeader>
        <CategoryForm
          category={category || undefined}
          onSave={handleSave}
          onCancel={handleCancel}
        />
      </DialogContent>
    </Dialog>
  );
};
